import { LitElement, html, css } from 'lit';
import { jhaStyles } from '../../../styles/jha-styles.js';

const styles = css`
  :host {
    display: flex;
    background-color: var(
      --jha-component-background-color,
      var(--primary-content-background-color)
    );
    align-items: center;
    border-radius: var(--jha-list-organizer-card-border-radius, 0px);
    --jha-border-color: transparent;
  }
  :host > div {
    display: flex;
    justify-content: space-between;
    position: relative;
    position: relative;
    width: 100%;
    margin-left: 36px;
    border-bottom: 1px solid
      var(--reorder-item-border-color, var(--divider-default-color));
    height: 100%;
  }
  :host span.icon-wrapper {
    display: flex;
    /*cursor: -webkit-grab;*/
    /*cursor: -moz-grab;*/
    /*cursor: grab;*/
    width: 24px;
    flex: 0 1 24px;
    align-self: stretch;
    align-items: center;
    justify-content: flex-end;
    margin-left: -30px;
    cursor: move;
    background: transparent;
  }
  svg {
    fill: var(--jha-list-organizer-handle-color, var(--jha-text-theme));
  }
  :host([drag='true']) {
    background-color: var(
      --jha-color-light,
      var(--secondary-content-background-color)
    ) !important;
    border-bottom: none !important;
    --jha-dropdown-menu-item-background-color: var(
      --jha-color-light,
      var(--secondary-content-background-color)
    );
  }
  :host([clone='true']) {
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.24), 0 1px 4px rgba(0, 0, 0, 0.12);
  }
  :host ::slotted(*) {
    width: 100%;
  }
  :host([draggable='false']) > div {
    display: block;
    margin: 0;
  }
  :host([draggable='false']) span.icon-wrapper {
    display: none;
  }
`;

export default class JhaReorderListItem extends LitElement {
  static get styles() {
    return [jhaStyles, styles];
  }

  static get properties() {
    return {
      itemId: {
        type: String,
      },
      title: {
        type: String,
      },
    };
  }

  constructor() {
    super();
    this.itemId = '';
    this.title = '';
  }

  render() {
    return html`
      <div drag-item>
        <!-- We can't use a custom element here. Event re-targeting kills drag events on Safari -->
        <span class="icon-wrapper">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            aria-label="Drag to move account"
          >
            <path d="M8,18h2v-2H8V18z M8,13h2v-2H8V13z M8,6v2h2V6H8z"></path>
            <path
              d="M13,18h2v-2h-2V18z M13,13h2v-2h-2V13z M13,6v2h2V6H13z"
            ></path>
          </svg>
        </span>
        <slot></slot>
      </div>
    `;
  }
}

export { styles as JhaReorderListItemStyles };
